import { Component, OnInit } from '@angular/core';
import { JobPointeService } from 'src/app/service/job-pointe/job-pointe.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { JobBoardService } from '../service/job-board.service';

@Component({
  selector: 'app-job-format-nav',
  templateUrl: './job-format-nav.component.html',
  styleUrls: ['./job-format-nav.component.scss'],
})
export class JobFormatNavComponent implements OnInit {
  constructor(
    private jobPointeService: JobPointeService,
    private sanitizer: DomSanitizer,
    private toastService: ToastService,
    private jobBoardService: JobBoardService,
  ) {}

  tagShapes: Array<any> = [];
  tags: Array<any> = [];
  selectedShape: any = {};
  selectedColor: string = '#000000';

  ngOnInit(): void {
    this.getTagShapes();
    this.getTags();
  }

  ngOnDestroy() {
    this.jobBoardService.formatShapeSelected.next({});
  }

  getTagShapes() {
    this.jobPointeService.read['jobBoardTagShapes']({}).subscribe(res => {
      let shapes = res.data;
      shapes.push({ name: 'None' });
      this.tagShapes = shapes;
    });
  }
  getTags() {
    this.jobPointeService.read['jobBoardTags']({}).subscribe(res => {
      this.tags = res.data;
    });
  }

  addNewTag(tagInput) {
    let label = tagInput.value;
    if (!label) return;
    if (!this.selectedShape?.name || this.selectedShape.name == 'eraser') {
      return this.toastService.showToast('Please select a valid tag shape.', 'error');
    }
    let params = {
      label,
      ...(this.selectedShape?.name && { shape: this.selectedShape.name }),
      color: this.selectedColor,
    };
    this.jobPointeService.create['jobBoardTag'](params).subscribe(
      res => {
        if (res.success) {
          this.toastService.showToast(res.message, 'success');
          this.getTags();
          tagInput.value = '';
        } else {
          this.toastService.showToast(res.error.message, 'error');
        }
      },
      err => {
        this.toastService.showToast('Error adding tag, please try again', 'error');
      },
    );
  }

  selectShape(shape) {
    this.selectedShape = shape;
    this.updateShapeAssetColor();
    this.jobBoardService.formatShapeSelected.next(this.selectedShape);
  }

  selectColor(color) {
    this.selectedColor = color;
    this.updateShapeAssetColor();
  }

  deleteTag(tag) {
    if (confirm(`Are you sure to remove tag: ${tag?.label}?`)) {
      this.jobPointeService.delete['jobBoardTag']({ id: tag.id }).subscribe(
        res => {
          if (res.success) {
            this.toastService.showToast(res.message, 'success');
            this.getTags();
          } else {
            this.toastService.showToast(res.error.message, 'error');
          }
        },
        err => {
          if (err.status == 423) {
            this.toastService.showToast('Tag is assigned and cannot be removed at this time.', 'error');
          } else {
            const { errors } = err.error;
            this.toastService.showToast(errors[0].message, 'error');
          }
        },
      );
    }
  }

  updateShapeAssetColor() {
    if (this.selectedShape?.asset) {
      this.selectedShape.asset = this.selectedShape.asset.replace(
        /(?<=<path\b[^<>]*)\s*\bfill=(["']).*?\1/,
        ` fill="${this.selectedColor}"`,
      );
      this.updateSelectedShapeSVG();
    }
  }

  updateSelectedShapeSVG() {
    if (this.selectedShape.name == 'eraser') {
      document.documentElement.style.setProperty('--selectedSVG', `url("${this.selectedShape.asset}")`);
    } else {
      let svgBase64 = btoa(this.selectedShape?.asset);
      document.documentElement.style.setProperty('--selectedSVG', `url("data:image/svg+xml;base64,${svgBase64}")`);
    }
  }

  sanitizeSVGString(svg: string) {
    let safeSVG: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(svg);
    return safeSVG;
  }
}
